import React from 'react';

import PropTypes from 'prop-types';

import { AddressInput } from './address-input';
import { AutoCompleteField } from '../../../constants/autocomplete-field';
import { FIELD_NAMES } from '../constants';

export const Line2Field = ({ optional = false }) => {
  return <AddressInput autoComplete={AutoCompleteField.AddressLine2} field={FIELD_NAMES.LINE2} optional={optional} />;
};

Line2Field.propTypes = {
  optional: PropTypes.bool,
};
